export const ru = {
  'app.name': 'Brain Hone',

  'nav.today': 'Сегодня',
  'nav.games': 'Игры',
  'nav.progress': 'Прогресс',

  'onboarding.hello': 'Добро пожаловать',
  'onboarding.helloName': 'Привет, {name}',
  'onboarding.p1.title': 'Четыре упражнения в день',
  'onboarding.p1.text': 'Две игры на память, две на внимание. Около шести минут.',
  'onboarding.p2.title': 'Сложность подстроится',
  'onboarding.p2.text': 'Уровень и темп меняются под вас - и по точности, и по скорости.',
  'onboarding.p3.title': 'Счёт уточнится за несколько дней',
  'onboarding.p3.text': 'Сначала оценка приблизительная. Через пять тренировок появится точный Hone Score - он сравнивает вас с вами же, а не с другими.',
  'onboarding.start': 'Начать первую тренировку',
  'home.morning': 'Доброе утро',
  'home.day': 'Добрый день',
  'home.evening': 'Добрый вечер',
  'home.workout': 'Тренировка дня',
  'home.continue': 'Продолжить',
  'home.left': 'осталось {n}',

  'insight.title': 'Что показала тренировка',
  'insight.accurateSlow.title': 'Точность отличная, темп спокойный',
  'insight.accurateSlow.advice': 'Попробуйте отвечать чуть раньше, чем почувствуете уверенность. Сложность поднимется, и тренировка станет полезнее.',
  'insight.fastSloppy.title': 'Быстро, но с ошибками',
  'insight.fastSloppy.advice': 'Здесь скорость не даёт выигрыша: ошибка стоит дороже сэкономленной секунды. Дайте себе полсекунды на проверку.',
  'insight.climbed.title': 'Уровень вырос в {n} упражнениях',
  'insight.climbed.advice': 'Задача подстроилась под вас. На новом уровне точность обычно временно падает - это нормально.',
  'insight.dropped.title': 'Уровень снизился',
  'insight.dropped.advice': 'Так и должно работать: игра ищет посильную сложность. Если это повторяется несколько дней подряд, попробуйте тренироваться в другое время суток.',
  'insight.gap.title': 'Разрыв между дисциплинами',
  'insight.gap.advice': 'Программа завтрашнего дня начнётся с отстающей дисциплины.',
  'insight.steady.title': 'Ровная тренировка',
  'insight.steady.advice': 'Показатели стабильны. Регулярность здесь важнее интенсивности - короткая тренировка каждый день даёт больше, чем длинная раз в неделю.',
  'insight.building.title': 'Идёт настройка под вас',
  'insight.building.advice': 'Первые заходы игра подбирает посильный уровень и темп. Через несколько тренировок станет комфортнее.',
  'index.title': 'Hone Score',
  'index.provisional': 'Предварительно · ещё {n} тренировок до точного счёта',
  'index.collectingHint': 'Ещё {n} тренировок - и появится ваш индекс',
  'index.weekChange': '{n} за неделю',

  'discipline.memory': 'Память',
  'discipline.attention': 'Внимание',
  'discipline.perception': 'Восприятие',

  'game.memoryMatrix': 'Memory Matrix',
  'game.memoryMatrix.hint': 'Запомните подсвеченные клетки',
  'game.memoryMatrix.recall': 'Отметьте клетки, которые горели ({n})',
  'game.memoryMatrix.review': 'Зелёные - верно, пунктир - пропущено',
  'game.missingOne': 'Missing One',
  'game.missingOne.hint': 'Какая фигура пропала?',
  'game.missingOne.study': 'Запомните фигуры',
  'game.snowflake': 'Snowflake',
  'game.snowflake.hint': 'Какой луч подходит к пустому сектору?',
  'game.stroop': 'Stroop',
  'game.stroop.hint': 'Нажмите цвет, которым написано слово',
  'game.reactionTarget': 'Reaction Target',
  'game.reactionTarget.hint': 'Найдите стрелку, повёрнутую иначе',

  'color.red': 'красный',
  'color.blue': 'синий',
  'color.green': 'зелёный',
  'color.yellow': 'жёлтый',
  'color.purple': 'фиолетовый',
  'color.orange': 'оранжевый',
  'color.teal': 'бирюзовый',
  'color.pink': 'розовый',
  'game.level': 'Уровень {n}',
  'game.done': 'Готово',

  'result.accuracy': 'Точность',
  'result.again': 'Ещё раз',
  'result.sessionDone': 'Заход завершён',
  'result.points': 'очков',
  'result.span': 'Объём',

  'today.sub': 'Программа на сегодня готова',
  'today.weak': 'Сегодня подтянем {d} - эти упражнения идут первыми',
  'today.start': 'Начать тренировку',
  'today.doneTitle': 'Тренировка завершена',
  'today.empty': 'На сегодня всё. Возвращайтесь завтра',
  'workout.next': 'Следующее упражнение',
  'workout.finish': 'Завершить тренировку',
  'games.sub': 'Любое упражнение, когда захочется',
  'progress.week': 'Последние 7 дней',
  'day.mon': 'Пн',
  'day.tue': 'Вт',
  'day.wed': 'Ср',
  'day.thu': 'Чт',
  'day.fri': 'Пт',
  'day.sat': 'Сб',
  'day.sun': 'Вс',
  'progress.sub': 'Считается относительно вашей собственной базы',
  'progress.sessions': 'Всего тренировок',
  'progress.bestSpan': 'лучший объём',
  'progress.sessionsShort': 'заходов',
  'progress.collecting': 'ещё {n} заходов до первого счёта',
  'progress.noData': 'Сыграйте несколько раз - и здесь появится динамика',
  'result.finish': 'Завершить',
  'reminder.title': 'Напоминания',
  'reminder.daily': 'Раз в день',
  'reminder.time': 'Во сколько',
  'reminder.hint': 'Напомним, если тренировка за день не пройдена',
  'reminder.denied': 'Нужно разрешить боту писать вам - иначе напоминание не дойдёт',
  'settings.theme': 'Тема',
  'settings.theme.auto': 'Авто',
  'settings.theme.light': 'Светлая',
  'settings.theme.dark': 'Тёмная',
  'settings.language': 'Язык',

  'common.streak': '{n} дней',
} as const
